import(/* webpackMode: "eager" */ "/home/agusylti/agudotng/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js");
import(/* webpackMode: "eager" */ "/home/agusylti/agudotng/src/app/_heros/Product/index.tsx")